import { Screen } from '~/screens/groups/show';

export const GroupsShow = () => <Screen />;
